import Vue from "vue";
import vuex from "vuex";

Vue.use(vuex);

import program from "./program_store";
import treminal from "./terminal";
import material from "./material";
import task from "./task_store";
import system from "./system";
import login from "./login";

export default new vuex.Store({
    modules: {
        program,
        treminal,
        material,
        task,
        system,
        login
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js